import { createSlice } from "@reduxjs/toolkit";
const initialState ={
 
}

const SliceGRNBinTransferReason = createSlice({
  name: "SliceGRNBinReason",
  initialState: { value: initialState },

  reducers: {
    GrnBinTransferReason_Set: (state, action) => {
      state.value = action.payload;
    },
    GrnBinTransferReason_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const {
  GrnBinTransferReason_Set,
  GrnBinTransferReason_Init, 
} = SliceGRNBinTransferReason.actions;
export default SliceGRNBinTransferReason.reducer;
